/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lifecycle status of a PAM player.
 * Additive in production — new values may be added without breaking existing code; removing one
 * breaks every generated client that names the member.
 * @export
 */
export const PamPlayerStatus = {
    _11184809: '11184809',
    active: 'active',
    probationary: 'probationary',
    deactivated: 'deactivated',
    self_excluded: 'self_excluded',
    suspended: 'suspended',
    unknown_default_open_api: '11184809'
} as const;
export type PamPlayerStatus = typeof PamPlayerStatus[keyof typeof PamPlayerStatus];


export function instanceOfPamPlayerStatus(value: any): boolean {
    for (const key in PamPlayerStatus) {
        if (Object.prototype.hasOwnProperty.call(PamPlayerStatus, key)) {
            if (PamPlayerStatus[key as keyof typeof PamPlayerStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PamPlayerStatusFromJSON(json: any): PamPlayerStatus {
    return PamPlayerStatusFromJSONTyped(json, false);
}

export function PamPlayerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerStatus {
    return json as PamPlayerStatus;
}

export function PamPlayerStatusToJSON(value?: PamPlayerStatus | null): any {
    return value as any;
}

